const queryProducts = ({ session, q, eventId }) => `
query {
  merchandises(limit: 16, activity: ${eventId}, session: "${session}", search: "${q}") {
    data {
      id
      userId
      name
      description
      images
      isGlobal
      storeId
      children
      category {
        id
        name
      }
      currency {
        iso
        symbol
      }
      type
      sku
      price
      offerPrice
      stock
      variations {
        data {
          id
          sku
          price
          offerPrice
          images
          searchCode
          quantity
          quantitySold
          stock
        }
      }
      specifications {
        data {
          key
          value
        }
      }
      metaData{
        data{
          key
          value
        }
      }
      specialPrices
    }
    totalCount
    organizer
  }
}
`;
const deliveryZones = ({ storeId }) => `query {
  merchandiseDeliveryZones(store: ${storeId}) {
    data {
      id
      name
      methods
      locations
    }
    totalCount
    ubigeo
  }
}`;
export default {
  queryProducts,
  deliveryZones
};
